import YearsItems from "../../../../src/client/katnh/widgets/YearsItems.js";
import * as React from 'react';
export default {
  YearsItems,
  React
};